module.exports = __webpack_public_path__ + "img/logo.9f0e2431.png";